import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Picture from '../../Picture'

class HomepageRecruit extends Component
{
    container = React.createRef()
    parallax = React.createRef()

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.container.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(60 * delta - 300) + 'px'
    }

    render() {
        return (
            <section className="section-default section-recruit" ref={this.container}>
                <div className="section-default-after section-recruit-after" ref={this.parallax}/>
                <div className="container">
                    <div className="default-head recruit-head">
                        <h2>
                            <FormattedMessage
                                id="portfolio.homepage.recruit.title"
                                defaultMessage="Un cabinet de recrutement avec des chasseurs de têtes spécialisés."
                            />
                        </h2>
                        <p className="default-text-subtitle recruit-subtitle">
                            <FormattedMessage
                                id="portfolio.homepage.recruit.subtitle"
                                defaultMessage="Urban Linker est un cabinet de recrutement innovant et expert des métiers du digital et de la tech, proposant un service dédié aux acteurs du Web et de l’écosystème start-up français."
                            />
                        </p>
                    </div>
                    <div className="default-wrap recruit-wrap">
                        <div className="default-img recruit-img">
                            <Picture
                                src={require("../../../../images/home-recruit.png")}
                                webp={require("../../../../images/home-recruit.webp")} />
                        </div>
                        <div className="default-text recruit-text">
                            <ul>
                                <li>
                                    <span>
                                        <FormattedMessage
                                            id="portfolio.homepage.recruit.list_1"
                                            defaultMessage=""
                                        />
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <FormattedMessage
                                            id="portfolio.homepage.recruit.list_2"
                                            defaultMessage=""
                                        />
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <FormattedMessage
                                            id="portfolio.homepage.recruit.list_3"
                                            defaultMessage=""
                                        />
                                    </span>
                                </li>
                            </ul>
                            <p className="default-text-subtitle recruit-text-subtitle">
                                <br/>
                                <FormattedMessage
                                    id="portfolio.homepage.recruit.subtitle_2"
                                    defaultMessage="Cerise sur le gateau"
                                />
                            </p>
                            <p className="default-text-paragraph recruit-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.recruit.paragraph_1"
                                    defaultMessage="Urban Linker propose une période de garantie sur les profils placés. Nous sommes présents sur le secteur du digital depuis 2009 : bénéficiez de notre expertise dans la recherche des meilleurs talents pour votre entreprise !"
                                />
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default HomepageRecruit;
